import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { loginUser } from "../api/api"
import { useAuth } from "./AuthProvider"

export default function Login(){

 const [email,setEmail] = useState("")
 const [password,setPassword] = useState("")

 const { login } = useAuth()
 const navigate = useNavigate()

 async function handleLogin(e){
  e.preventDefault()

  try{

   const res = await loginUser({
    email,
    password
   })

   const { token, user } = res.data

   // 🔥 SAVE TOKEN + ROLE
   localStorage.setItem("token", token)
   localStorage.setItem("role", user.role)

   login(token, user)

   // 🔥 REDIRECT BASED ON ROLE
   if(user.role === "superadmin"){
     navigate("/admin/settings")
   }else if(user.role === "admin"){
     navigate("/admin/users")
   }else{
     navigate("/dashboard")
   }

  }catch(err){
   console.error(err)
   alert(err.response?.data?.error || "Login failed")
  }

 }

 return(

  <form className="auth" onSubmit={handleLogin}>

   <h1>GLV SEO Login</h1>

   <input
    placeholder="Email"
    value={email}
    onChange={e=>setEmail(e.target.value)}
   />

   <input
    type="password"
    placeholder="Password"
    value={password}
    onChange={e=>setPassword(e.target.value)}
   />

   <button type="submit">
    Login
   </button>

  </form>

 )

}
